(function () {
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

  function init(section) {
    if (!section || section.dataset.ocBound === '1') return;
    section.dataset.ocBound = '1';

    let ticking = false;
    let peakProg = 0;
    function update() {
      ticking = false;
      const rect = section.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const sectionCenter = rect.top + rect.height / 2;
      const viewportCenter = vh / 2;
      const dist = Math.abs(sectionCenter - viewportCenter);
      const range = vh / 2;
      const rawProg = clamp(1 - dist / range, 0, 1);
      const easedRaw = rawProg * rawProg * (3 - 2 * rawProg);
      if (easedRaw > peakProg) peakProg = easedRaw;
      const eased = peakProg;
      section.style.setProperty('--oc-prog', eased.toFixed(4));
      if (eased >= 0.999) {
        section.style.setProperty('background', 'linear-gradient(90deg, #B5BA67 1%, #15707A 53%)', 'important');
      } else {
        section.style.removeProperty('background');
      }
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function boot() {
    document.querySelectorAll('[data-oura-compare]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const sec = e.target.querySelector('[data-oura-compare]');
    if (sec) init(sec);
  });
})();
